// TODO: Eventually this should be dynamic, based on user choice
export const locale = "en";
